<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4 py-10">
    <div class="w-full max-w-sm">
      <!-- Logo: staccato, sospeso sopra la card -->
      <div class="flex justify-center mb-8">
        <div class="h-20 w-20 rounded-2xl bg-gray-900 flex items-center justify-center shadow-xl">
          <Nibble classes="h-10 w-10 text-ynibble" />
        </div>
      </div>

      <div class="rounded-2xl bg-white border border-gray-200 shadow-xl px-8 py-8">
        <div class="text-center mb-7">
          <p class="text-xs font-semibold uppercase tracking-widest text-onibble" style="font-family: 'Exo2', 'Helvetica', sans-serif">myNibble</p>
          <h1 class="mt-1 text-2xl font-bold text-gray-800" style="font-family: 'Exo2', 'Helvetica', sans-serif">{{ title }}</h1>
          <p v-if="subtitle" class="mt-2 text-sm text-gray-500 leading-snug">{{ subtitle }}</p>
        </div>

        <slot />
      </div>

      <p class="mt-6 text-center text-xs tracking-wide text-gray-400">© {{ year }} Nibble S.r.l.</p>
    </div>
  </div>
</template>

<script>
import Nibble from '@/icons/components/logos/Nibble.vue';

export default {
  name: 'AuthShell',
  components: { Nibble },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
